import { Component, OnInit } from '@angular/core';
import { IUserSessionData, UserState } from '../../../../store/models/user.model';
import { EReducers, IReducers } from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { EventService } from '../../../../store/services/event.service';
import { IToggleLeftMenuPayload, TOGGLE_LEFT_MENU_TYPE } from '../../../../store/models/page.model';


@Component({
  selector: 'app-authenticated-header',
  templateUrl: './authenticated-header.component.html',
  styleUrls: ['./authenticated-header.component.scss'],
})
export class AuthenticatedHeaderComponent implements OnInit {
  userSession: IUserSessionData;
  protected readonly bars = faBars;

  private leftMenuOpened: boolean;

  constructor(
    private store: Store<IReducers>,
    private readonly eventService: EventService,
  ) {
  }

  ngOnInit() {
    this.store.select(EReducers.USER).subscribe((userState: UserState) => {
      if (userState.sessionData && userState.loggedIn) {
        this.userSession = userState.sessionData;
      }
    });
    this.eventService.on<IToggleLeftMenuPayload>(TOGGLE_LEFT_MENU_TYPE).subscribe(menuState => this.leftMenuOpened = menuState.opened);
  }

  toggleLeftMenu() {
    this.leftMenuOpened = !this.leftMenuOpened;
    this.eventService.broadcast<IToggleLeftMenuPayload>(TOGGLE_LEFT_MENU_TYPE, {
      opened: this.leftMenuOpened,
    });
  }
}
